import React from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Input,
  Button,
  InputGroup,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import { sessionEnded } from "../user/SessionEnded";
import Api from "../../components/helpers/Api";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";

class AdminSongBooks extends React.Component {
  state = {
    isLoading: false,
    songBooks: [],
    searchQuery: "",
    unauthorized: false,
  };

  componentDidMount() {
    try {
      const customer = sessionStorage.getItem("customer");
      const parsed = customer ? JSON.parse(customer) : null;
      if (parsed?.user?.isAdmin) {
        this.loadSongBooks();
      } else {
        this.setState({ unauthorized: true });
      }
    } catch (e) {
      console.error("AdminSongBooks componentDidMount error:", e);
      this.setState({ unauthorized: true });
    }
  }

  loadSongBooks = (search = "") => {
    const params = new URLSearchParams();
    if (search.trim()) {
      params.append("search", search.trim());
    }
    this.setState({ isLoading: true });
    Api.get(`/api/admin/song-books?${params.toString()}`)
      .then(response => {
        this.setState({
          songBooks: response.data,
          isLoading: false,
        });
      })
      .catch(err => {
        console.error("Error fetching song books:", err);
        this.setState({ isLoading: false });
      });
  };

  handleSearchChange = e => {
    this.setState({ searchQuery: e.target.value });
  };

  handleSearchSubmit = e => {
    e.preventDefault();
    this.loadSongBooks(this.state.searchQuery);
  };

  handleClearSearch = () => {
    this.setState({ searchQuery: "" }, () => this.loadSongBooks(""));
  };

  render() {
    if (!sessionStorage.getItem("customer")) {
      return sessionEnded();
    }
    if (this.state.unauthorized) return <Navigate to="/" />;

    const { isLoading, songBooks, searchQuery } = this.state;

    return (
      <>
        <SeoNoIndex noindex={true} />

        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows <span>manage song books</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 2560 100">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>

        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="10">
                <Card className="shadow border-0">
                  <CardBody className="p-4">

                    <Button
                      color="link"
                      onClick={() => this.props.navigate("/admin")}
                      className="mb-3 p-0"
                    >
                      &larr; Back to menu
                    </Button>

                    <h2 className="mb-4">Song Books</h2>

                    <Form onSubmit={this.handleSearchSubmit} className="mb-4">
                      <FormGroup>
                        <Label for="songBookSearch">Search song books</Label>
                        <InputGroup>
                          <Input
                            id="songBookSearch"
                            type="text"
                            value={searchQuery}
                            onChange={this.handleSearchChange}
                            placeholder="Search by title or code…"
                          />
                          <Button type="submit" color="primary">Search</Button>
                          <Button
                            type="button"
                            color="secondary"
                            onClick={this.handleClearSearch}
                            disabled={!searchQuery}
                          >
                            Clear
                          </Button>
                        </InputGroup>
                      </FormGroup>
                    </Form>

                    {isLoading ? (
                      <p className="text-muted">Loading…</p>
                    ) : (
                      <ul className="list-group">
                        {songBooks.length > 0 ? (
                          songBooks.map(sb => (
                            <li
                              key={sb.id}
                              className="list-group-item list-group-item-action"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.props.navigate(`/admin/song-book/${sb.id}`)}
                            >
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>{sb.title}</strong>
                                  {sb.shortTitle && (
                                    <span className="text-muted ms-2">({sb.shortTitle})</span>
                                  )}
                                </div>
                                <span className="badge bg-secondary rounded-pill">
                                  {sb.songCount} {sb.songCount === 1 ? "song" : "songs"}
                                </span>
                              </div>
                            </li>
                          ))
                        ) : (
                          <li className="list-group-item text-muted">
                            No song books found.
                          </li>
                        )}
                      </ul>
                    )}

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

function withRouterParamsAndNavigate(Component) {
  return function Wrapped(props) {
    const navigate = useNavigate();
    const params = useParams();
    return <Component {...props} navigate={navigate} params={params} />;
  };
}

export default withRouterParamsAndNavigate(AdminSongBooks);
